import type { ChainId } from '@venusprotocol/chains';

export const SUNSET_CHAIN_IDS: ChainId[] = [];
